// extracted by mini-css-extract-plugin
export default {"container":"horizontal_container__BVjH2","item":"horizontal_item__5V3vT"};